<div class="block" [id]="idName" style="width: 100%; height: 95%;"></div>
